
import { useAppDispatch } from 'hooks/useAppDispatch';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import store from '../store';
import { getCountries } from '../store/countries/countries-actions';

const useCountry = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    // @ts-ignore
    const { countries } = store.getState();

    if (countries.data && countries.data.length > 0) return;

    dispatch(getCountries());
  }, [dispatch]);

  // @ts-ignore
  const data = useSelector((state: RootState) => state.countries.data);

  // @ts-ignore
  const countries = Array.from(data).sort((a, b) => (a.name > b.name ? 1 : -1));

  return countries;
};

export default useCountry;
